//TODO: https://uberall.atlassian.net/browse/REP-5098
/* istanbul ignore file -- @preserve */
import { get, post } from './apiClient';
import {
    ApiSurveyFormResponse,
    SubmitSurveyFormResponse,
    SubmitSurveyFormResponsePayload,
} from '../types/survey';

const getSurveyApiUrl = () => '/api/surveys';

export const SurveyAPI = {
    fetchSurveyForm: async (unique_id: string): Promise<ApiSurveyFormResponse> => {
        const url = `${getSurveyApiUrl()}/public/${unique_id}`;
        return await get(url);
    },
    submitSurveyForm: async (
        payload: SubmitSurveyFormResponsePayload
    ): Promise<SubmitSurveyFormResponse> => {
        const url = `${getSurveyApiUrl()}/public/${payload.uniqueId}/response`;
        return await post<SubmitSurveyFormResponse>(url, payload);
    },
};
